import { OptionProps, components } from 'react-select';
import { FrontendFilterValue } from '../../types/filters.type';

const { Option } = components;

export default function CustomOption(props: OptionProps<FrontendFilterValue, true>) {
  const { data } = props;

  return (
    <div>
      <Option {...props}>
        <div id={data.id}>{data.displayName}</div>
      </Option>
    </div>
  );
}
